export enum SolButtonVariantEnum {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Outlined = 'outlined',
}

export type SolButtonVariant = `${SolButtonVariantEnum}`;

export enum SolButtonSizeEnum {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export type SolButtonSize = `${SolButtonSizeEnum}`;
